import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const inputStyle = css`
    flex: 1 1;

    padding-bottom: ${Spacing.MD}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;

export const controlStyle = css`
    flex: 1 1;

    padding-bottom: ${Spacing.MD}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;

export const Divider = styled.div`
    margin-bottom: ${Spacing.MD}px;
    border-bottom: 1px solid ${Colors.Gray.V150};
`;

export const copyButton = css`
    cursor: pointer;

    float: right;

    color: ${Colors.Blue.V200};
    text-decoration: none;

    background: white;
    border: none;
`;

export const footer = css`
    text-align: right;
`;

export const buttonStyle = css`
    margin-left: ${Spacing.MD}px;
`;

export const buttonIcon = css`
    margin-right: 5px;
    vertical-align: text-top;
`;

export const iconPreview = css`
    max-width: 150;
    max-height: 150;
    margin: 5;
`;
